import { ComponentChildren } from "preact";

import { Container } from "@components/ui/structure/container";
import { DataAccessView } from "@components/view/data-access-view";
import { ErrorView } from "@components/view/not-found-view";
import { PermissionManagementView } from "@components/view/permission-management-view";
import { RoleManagementView } from "@components/view/role-management-view";
import { UserManagementView } from "@components/view/user-management-view";
import { DataAccessProvider } from "@contexts/data-access";
import { PermissionManagementProvider } from "@contexts/permission-management";
import { RoleManagementProvider } from "@contexts/role-management";
import { UserManagementProvider } from "@contexts/user-management";
import { useClasses } from "@styles";
import { LayoutProps, PageProps, useRouter } from "@utils/router";

type Provider = (props: {
  children: ComponentChildren
}) => ComponentChildren;

function Layout({ dynamic, children }: LayoutProps) {
  const Provider: Provider = ({
    "users": UserManagementProvider,
    "roles": RoleManagementProvider,
    "permissions": PermissionManagementProvider,
    "data": DataAccessProvider,
  }[dynamic || "unknown"]) || (
    ({ children }) => <>{children}</>
  );

  if (!dynamic)
    return (<>
      <ErrorView
        code={404}
        message="Product not available"
      />
    </>);

  return (<>
    <Container className={useClasses("home-view")}>
      <Container
        className={useClasses("home-view-header")}
        children={null}
      />

      <Provider>
        {children}
      </Provider>
    </Container>
  </>);
}

export function ManagePage({ forwarded } : PageProps) {
  return useRouter(forwarded, Layout, {
    "users": UserManagementView,
    "roles": RoleManagementView,
    "permissions": PermissionManagementView,
    "data": DataAccessView,
  });
}

